/* ================================================================
   LILIMAUS Produkt-Chat "Frage zum Produkt?" (Marc, 2026-07-07)
   ----------------------------------------------------------------
   DESIGN-PROTOTYP (Demo-Modus): Der Bot antwortet mit Beispiel-
   texten. Die echte Anbindung (LILIMAUS-OS: KI-Antworten aus dem
   CS-Wiki, Ticket-Erstellung, Fragen-Logging) haengt spaeter an
   den markierten TODO-Stellen (sendToBot / createTicket / logEvent).

   Bausteine:
   1) Floating-Button unten rechts (weicht der Sticky-ATC-Bar aus)
   2) Inline-Trigger, haengt sich selbst unter .buy-buttons
   3) Chat-Panel: Produkt-/Varianten-Kontext live, Quick-Chips,
      Demo-Antworten, "War das hilfreich?", Upsell-Karte
      (Shopify-Recommendations als Platzhalter fuer BQ-Co-Purchase),
      Ticket-Formular mit E-Mail.
   Kein Tracking-/Pixel-Code, keine Theme-Aenderungen ausserhalb
   des eigenen Markups.
   ================================================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('lmchat-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var PRODUCT = CFG.product || null;
  // 'product' (PDP: Kontext-Chip, Inline-Trigger, Upsell) oder
  // 'support' (Kontaktseite: Self-Service, ohne Produktbezug)
  var MODE = CFG.mode || 'product';
  // demo=true: Beispielantworten ohne Backend (Design-Harness);
  // demo=false: echtes LILIMAUS-Chat-Backend unter CFG.apiBase
  var DEMO = CFG.demo !== false;
  var API = (CFG.apiBase || '').replace(/\/$/, '');

  function getSessionId() {
    try {
      var sid = sessionStorage.getItem('lmchat-sid');
      if (!sid) {
        sid = 'lm-' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2, 10));
        sessionStorage.setItem('lmchat-sid', sid);
      }
      return sid;
    } catch (e) {
      return 'lm-fallback';
    }
  }

  function api(path, payload, keepalive) {
    var ctrl = window.AbortController ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 28000);
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: !!keepalive,
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { return r.json(); });
  }

  /* Antwort Token-fuer-Token lesen (NDJSON-Strom vom /api/chat/stream).
     handlers.onDelta(text) pro Haeppchen, handlers.onDone(hadError) am Ende.
     Wirft, wenn Streaming nicht moeglich ist (alter Browser / harter Netz-/
     Serverfehler) -> askQuestion faellt dann auf /api/chat zurueck. */
  function streamChat(payload, handlers) {
    var ctrl = window.AbortController ? new AbortController() : null;
    // Streaming darf laenger dauern als ein Einzelaufruf
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 45000) : null;
    function clear() { if (timer) { clearTimeout(timer); timer = null; } }
    return fetch(API + '/api/chat/stream', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok || !r.body || !r.body.getReader) { clear(); throw new Error('nostream'); }
      var reader = r.body.getReader();
      var dec = new TextDecoder();
      var buf = '', hadError = false;
      function handleLine(line) {
        line = line.trim();
        if (!line) return;
        var o; try { o = JSON.parse(line); } catch (e) { return; }
        if (o.t === 'd' && o.text) handlers.onDelta(o.text);
        else if (o.t === 'done') hadError = !!o.error;
      }
      function pump() {
        return reader.read().then(function (res) {
          if (res.done) {
            clear();
            buf += dec.decode();
            if (buf.trim()) handleLine(buf);
            handlers.onDone(hadError);
            return;
          }
          buf += dec.decode(res.value, { stream: true });
          var nl;
          while ((nl = buf.indexOf('\n')) >= 0) {
            handleLine(buf.slice(0, nl));
            buf = buf.slice(nl + 1);
          }
          return pump();
        });
      }
      return pump();
    }, function (err) { clear(); throw err; });
  }

  // Nur diese Ereignisse gehen vom Client nach BigQuery — Frage/Antwort,
  // Gutschein und Ticket loggt der Server selbst (keine Dubletten).
  var CLIENT_EVENT_TYPES = { open: 1, close: 1, feedback: 1, thankyou_shown: 1, handoff_click: 1, whatsapp_click: 1 };

  function sendEvent(type, data) {
    if (DEMO || !API || !CLIENT_EVENT_TYPES[type]) return;
    try {
      api('/api/events', {
        sessionId: getSessionId(),
        mode: MODE,
        type: type,
        page: location.href.slice(0, 500),
        productHandle: PRODUCT ? PRODUCT.handle : null,
        variant: state.variant ? state.variant.title : null,
        question: (data && data.question) || null,
        helpful: data && typeof data.helpful === 'boolean' ? data.helpful : null,
        meta: data || null
      }, true).catch(function () { /* Logging darf nie stoeren */ });
    } catch (e) { /* noop */ }
  }

  /* ---------------- Logging-Stub (Kern des Projekts!) ----------
     Jede Kundenfrage soll gesammelt werden, um Kaufhuerden zu
     erkennen. Demo: sessionStorage + console. Spaeter: POST an
     LILIMAUS-OS (z. B. /api/shop-chat/events). */
  function logEvent(type, data) {
    var evt = {
      t: new Date().toISOString(),
      type: type,
      mode: MODE,
      product: PRODUCT ? PRODUCT.handle : null,
      variant: state.variant ? state.variant.title : null,
      data: data || {}
    };
    try {
      var log = JSON.parse(sessionStorage.getItem('lmchat-log') || '[]');
      log.push(evt);
      sessionStorage.setItem('lmchat-log', JSON.stringify(log));
    } catch (e) { /* storage voll/blockiert -> egal */ }
    if (window.console && console.info) console.info('[lmchat]', evt);
    // Live-Betrieb: whitelisted Ereignisse ans Backend (BigQuery);
    // Frage/Antwort, Gutschein und Ticket loggt der Server selbst.
    sendEvent(type, data);
  }

  /* ---------------- State ---------------- */
  var state = {
    open: false,
    started: false,
    variant: null,
    lastQuestion: '',
    thanksShown: false,
    transcript: [],
    sessionActive: false,   // true ab der ersten Kundenfrage
    savedTranscript: null,  // Verlauf aus frueherem Seitenaufruf (Replay)
    voucher: null           // ausgegebener Gutschein {code, endsAt, percent} -> ueber Seitenwechsel mitnehmen
  };

  /* ---------------- Session ueber Seitenwechsel ----------------
     Der Chat soll beim Durchklicken durch den Shop erhalten bleiben
     (Ansage Marc 2026-07-07): Verlauf + Offen-Zustand liegen in
     sessionStorage (pro Tab, endet mit dem Browser-Tab). */
  var SESS_KEY = 'lmchat-session';

  function loadSession() {
    try { return JSON.parse(sessionStorage.getItem(SESS_KEY) || 'null'); } catch (e) { return null; }
  }

  function saveSession() {
    if (!state.sessionActive) return; // erst speichern, wenn wirklich gechattet wurde
    try {
      sessionStorage.setItem(SESS_KEY, JSON.stringify({
        active: true,
        open: state.open,
        thanksShown: state.thanksShown,
        voucher: state.voucher || null,
        transcript: state.transcript.slice(-40)
      }));
    } catch (e) { /* Storage blockiert -> Chat funktioniert trotzdem, nur ohne Persistenz */ }
  }

  /* ---------------- Varianten-Erkennung ----------------
     Initial aus ?variant= bzw. selected_or_first_available (Liquid),
     danach: Change-Events + MutationObserver auf input[name="id"]
     + History-Hook (Theme schreibt ?variant= in die URL). */
  function variantById(id) {
    if (!PRODUCT || !id) return null;
    for (var i = 0; i < PRODUCT.variants.length; i++) {
      if (String(PRODUCT.variants[i].id) === String(id)) return PRODUCT.variants[i];
    }
    return null;
  }

  function currentVariantId() {
    var url = new URLSearchParams(location.search).get('variant');
    if (url) return url;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return CFG.initialVariantId || null;
  }

  function refreshVariant() {
    var v = variantById(currentVariantId());
    if (!v && PRODUCT && PRODUCT.variants.length) v = PRODUCT.variants[0];
    var changed = !state.variant || (v && v.id !== state.variant.id);
    state.variant = v;
    if (changed) renderContext();
  }

  function watchVariant() {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], variant-picker, .product-info')) {
        setTimeout(refreshVariant, 50);
      }
    }, true);

    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && window.MutationObserver) {
      new MutationObserver(function () { refreshVariant(); })
        .observe(input, { attributes: true, attributeFilter: ['value'] });
    }

    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      history[fn] = function () {
        var r = orig.apply(this, arguments);
        setTimeout(refreshVariant, 0);
        return r;
      };
    });
    window.addEventListener('popstate', function () { setTimeout(refreshVariant, 0); });
  }

  /* ---------------- Sticky-ATC-Bar-Ausweichen ----------------
     Die Theme-Bar (.sticky-add-to-cart-wrapper, fixed bottom,
     z=300) erscheint beim Scrollen. Button/Panel heben sich um
     ihre Hoehe an (CSS-Var --lmchat-lift). */
  function watchStickyBar() {
    var root = document.documentElement;
    function measure() {
      var lift = 0;
      var bar = document.querySelector('.sticky-add-to-cart-wrapper');
      if (bar) {
        var r = bar.getBoundingClientRect();
        var cs = getComputedStyle(bar);
        var visible = r.height > 0 && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05 &&
          r.top < window.innerHeight - 4;
        // Manche Themes verstecken die Bar via translateY am inneren Element:
        if (visible) {
          var inner = bar.firstElementChild;
          if (inner) {
            var ri = inner.getBoundingClientRect();
            visible = ri.top < window.innerHeight - 4 && ri.height > 0;
            if (visible) lift = Math.max(0, window.innerHeight - ri.top);
          } else {
            lift = r.height;
          }
        }
      }
      root.style.setProperty('--lmchat-lift', Math.round(Math.min(lift, 160)) + 'px');
    }
    var pending = false;
    function onScroll() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; measure(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setInterval(measure, 800); // Fallback: Bar togglet auch ohne Scroll (z. B. Varianten-Sheet)
    measure();
  }

  /* ---------------- Theme-Overlays (Drawer/Modals) ----------------
     Warenkorb-Drawer, Menue, Suche und Quick-View liegen als Modal
     ueber der Seite; das Theme (main.mjs) setzt dabei body.no-scroll.
     Solange ein Overlay offen ist, tritt der Chat komplett zurueck
     (--yield), damit er z. B. nie den Kasse-Button verdeckt. */
  function watchOverlays() {
    function overlayOpen() {
      if (document.body.classList.contains('no-scroll')) return true;
      // Fallback, falls ein Modal den Body nicht sperrt:
      return !!document.querySelector('.modal[open], cart-modal[open], search-modal[open]');
    }
    function apply() {
      var yieldNow = overlayOpen();
      [fab, panel, backdrop].forEach(function (n) {
        if (n) n.classList.toggle('--yield', yieldNow);
      });
    }
    if (window.MutationObserver) {
      new MutationObserver(apply).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    setInterval(apply, 800); // Sicherheitsnetz fuer Modals ohne Body-Lock
    apply();
  }

  /* ---------------- Markup-Helfer ---------------- */
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Bot-Antworten kommen als Mini-Markdown. Erst alles escapen (kein HTML vom
  // Modell), dann nur [Text](URL)-Links, nackte URLs und **fett** rendern.
  // Schreibt das Modell die URL doppelt ([url](url)), zeigen wir sie nur einmal
  // und ohne Protokoll. Nur fuer Bot-Blasen — User-Text bleibt textContent.
  function richHtml(text) {
    var h = esc(text);
    h = h.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_, label, url) {
      if (label === url) label = label.replace(/^https?:\/\//, '');
      return '<a href="' + url + '" target="_blank" rel="noopener">' + label + '</a>';
    });
    h = h.replace(/(^|[^">])(https?:\/\/[^\s<]*[^\s<.,!?;:)"'])/g, function (_, pre, url) {
      return pre + '<a href="' + url + '" target="_blank" rel="noopener">' + url.replace(/^https?:\/\//, '') + '</a>';
    });
    return h.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_SEND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>';
  var ICON_WA = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.28-1.38a9.9 9.9 0 0 0 4.76 1.21h.01c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.02h-.01a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.13.82.84-3.05-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24zm4.52-6.17c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.15.16-.29.18-.53.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.71-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.43h-.47c-.16 0-.43.06-.65.31-.22.24-.85.83-.85 2.03s.87 2.35.99 2.51c.12.16 1.71 2.61 4.14 3.66.58.25 1.03.4 1.38.51.58.19 1.11.16 1.53.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29z"/></svg>';

  /* ---------------- DOM-Aufbau ---------------- */
  var fab, panel, backdrop, msgsEl, ctxEl, inputEl;

  function buildFab() {
    fab = el('button', 'lmchat-fab', ICON_CHAT + '<span class="lmchat-fab__label">' + esc(CFG.buttonLabel) + '</span><span class="lmchat-fab__badge" aria-hidden="true"></span>');
    fab.type = 'button';
    fab.setAttribute('aria-haspopup', 'dialog');
    fab.setAttribute('aria-expanded', 'false');
    fab.addEventListener('click', openPanel);
    document.body.appendChild(fab);
    // Nach erstem Scroll-Stueck einklappen (Label weg), Platz sparen:
    var collapsed = false;
    window.addEventListener('scroll', function () {
      if (!collapsed && window.scrollY > 600) {
        collapsed = true;
        fab.classList.add('--collapsed');
        fab.setAttribute('aria-label', CFG.buttonLabel);
      }
    }, { passive: true });
  }

  // Inline-Trigger unter den Buy-Buttons: auf Marcs Ansage 2026-07-07
  // wieder entfernt – Einstieg ist nur noch der Floating-Button.

  function buildPanel() {
    // Abdunkelung (nur Mobile sichtbar): Tipp daneben schliesst den Chat
    backdrop = el('button', 'lmchat-backdrop');
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', 'Chat schließen');
    backdrop.addEventListener('click', closePanel);
    document.body.appendChild(backdrop);

    panel = el('section', 'lmchat-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-label', CFG.headTitle);

    // Griff-Leiste (nur Mobile): grosse Flaeche zum Zuziehen des Sheets
    var grab = el('button', 'lmchat-grab', '<i></i>');
    grab.type = 'button';
    grab.setAttribute('aria-label', 'Chat schließen');
    grab.addEventListener('click', closePanel);

    var head = el('div', 'lmchat-head',
      '<div class="lmchat-head__avatar">LILI</div>' +
      '<div class="lmchat-head__txt">' +
      '<div class="lmchat-head__title">' + esc(CFG.headTitle) + '</div>' +
      '<div class="lmchat-head__status"><span class="lmchat-head__dot"></span>' + esc(CFG.headStatus) + '</div>' +
      '</div>' +
      '<button type="button" class="lmchat-head__close" aria-label="Chat schließen">' + ICON_X + '</button>');
    head.querySelector('.lmchat-head__close').addEventListener('click', closePanel);

    // Demo-Banner nur zeigen, wenn ein Hinweistext gesetzt ist (Live: leer)
    var demo = CFG.demoNote ? el('div', 'lmchat-demo', esc(CFG.demoNote)) : null;

    ctxEl = el('div', 'lmchat-ctx');

    msgsEl = el('div', 'lmchat-msgs');
    msgsEl.setAttribute('aria-live', 'polite');

    var inputbar = el('div', 'lmchat-inputbar');
    inputEl = el('textarea');
    inputEl.rows = 1;
    inputEl.placeholder = CFG.inputPlaceholder;
    inputEl.setAttribute('aria-label', CFG.inputPlaceholder);
    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        submitInput();
      }
    });
    var send = el('button', 'lmchat-send', ICON_SEND);
    send.type = 'button';
    send.setAttribute('aria-label', 'Frage senden');
    send.addEventListener('click', submitInput);
    inputbar.appendChild(inputEl);
    inputbar.appendChild(send);

    // Fusszeile mit dauerhafter Mensch-Uebergabe
    var foot = el('div', 'lmchat-foot', esc(CFG.footNote) + ' · ');
    var human = el('button', 'lmchat-foot__human', esc(CFG.humanLink));
    human.type = 'button';
    human.addEventListener('click', function () {
      logEvent('handoff_click');
      showTicketForm(true);
    });
    foot.appendChild(human);

    panel.appendChild(grab);
    panel.appendChild(head);
    if (demo) panel.appendChild(demo);
    if (PRODUCT) panel.appendChild(ctxEl); // Support-Modus: kein Produkt-Chip
    panel.appendChild(msgsEl);
    panel.appendChild(inputbar);
    panel.appendChild(foot);
    document.body.appendChild(panel);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.open) closePanel();
    });
  }

  function renderContext() {
    if (!ctxEl || !PRODUCT) return;
    var v = state.variant;
    var vLine = v
      ? 'Variante: <b>' + esc(v.title) + '</b>' + (v.price ? ' &middot; ' + esc(v.price) : '')
      : '';
    ctxEl.innerHTML =
      (PRODUCT.image ? '<img class="lmchat-ctx__img" src="' + esc(PRODUCT.image) + '" alt="" loading="lazy">' : '') +
      '<div class="lmchat-ctx__txt">' +
      '<span class="lmchat-ctx__label">' + esc(CFG.ctxLabel) + '</span>' +
      '<span class="lmchat-ctx__title">' + esc(PRODUCT.title) + '</span>' +
      (vLine ? '<span class="lmchat-ctx__variant">' + vLine + '</span>' : '') +
      '</div>';
  }

  /* ---------------- Chat-Mechanik ---------------- */
  function scrollDown() { msgsEl.scrollTop = msgsEl.scrollHeight; }

  function addMsg(who, text) {
    var m = el('div', 'lmchat-msg --' + who);
    if (who === 'bot') m.innerHTML = richHtml(text); else m.textContent = text;
    msgsEl.appendChild(m);
    scrollDown();
    state.transcript.push({ who: who, text: text });
    saveSession();
    if (who === 'bot') markUnread(); // Bot-Nachricht bei geschlossenem Panel -> Badge
    return m;
  }

  // Ungelesen-Punkt am Chat-Button, wenn Inhalt ankommt, waehrend das Panel zu ist
  function markUnread() {
    if (!state.open && fab) fab.classList.add('--unread');
  }

  function showTyping() {
    var t = el('div', 'lmchat-typing', '<i></i><i></i><i></i>');
    msgsEl.appendChild(t);
    scrollDown();
    return t;
  }

  function addChips(labels, onPick) {
    var wrap = el('div', 'lmchat-chips');
    labels.forEach(function (label) {
      var c = el('button', 'lmchat-chip');
      c.type = 'button';
      c.textContent = label;
      c.addEventListener('click', function () {
        wrap.remove();
        onPick(label);
      });
      wrap.appendChild(c);
    });
    msgsEl.appendChild(wrap);
    scrollDown();
  }

  function greet() {
    if (state.started) return;
    state.started = true;
    // Echten Verlauf (mit Kundenfrage) aus vorheriger Seite abspielen;
    // nur-Begruessung zaehlt nicht -> dann lieber frisch mit Chips starten
    var hasUserMsg = (state.savedTranscript || []).some(function (m) { return m.who === 'user'; });
    if (hasUserMsg) {
      state.savedTranscript.forEach(function (m) { addMsg(m.who, m.text); });
      state.savedTranscript = null;
      // Ausgegebener Gutschein aus vorheriger Seite -> Karte wieder anhaengen
      // (mit Original-Code + weiterlaufendem Countdown gegen endsAt).
      if (state.voucher && state.voucher.code) {
        appendVoucherCard(state.voucher);
        scrollDown();
      }
      return;
    }
    state.savedTranscript = null;
    state.transcript = [];
    var name = PRODUCT ? PRODUCT.title : 'unserem Shop';
    addMsg('bot', CFG.greeting.replace('{product}', name));
    addChips(CFG.quickReplies, function (label) { askQuestion(label); });
  }

  function submitInput() {
    var q = (inputEl.value || '').trim();
    if (!q) return;
    inputEl.value = '';
    askQuestion(q);
  }

  /* Fragt jemand aktiv nach Rabatt/Gutschein, bekommt er sofort den
     Dankeschoen-Code (Ansage Marc 2026-07-07). Einloesen-Probleme
     ("Code klappt nicht") zaehlen NICHT als Rabatt-Wunsch. */
  function isDiscountAsk(s) {
    if (/(einlös|einloes|klappt|funktioniert|geht nicht|fehler|ungültig|ungueltig)/.test(s)) return false;
    return /(rabatt|gutschein|coupon|promo|aktionscode|discount|günstiger|guenstiger|\bcode\b)/.test(s);
  }

  /* Preisfrage: LILI nennt bewusst keine Preise (die Produktseite ist die
     Quelle) — als Kauf-Verstaerker gibt es direkt den Dankeschoen-Gutschein
     dazu (Ansage Marc 2026-07-10). Danach kommt KEINE zweite Karte mehr
     (state.thanksShown + Session-Einmaligkeit im Backend).
     "kostenlos"/"Versandkosten"/Retoure zaehlen nicht als Preisfrage. */
  function isPriceAsk(s) {
    if (/(kostenlos|versandkosten|retoure|rücksend|ruecksend)/.test(s)) return false;
    return /(\bpreis|kostet|kosten\b|wie teuer|zu teuer|€|\beuro\b)/.test(s);
  }

  /* Kunde will ausdruecklich einen Menschen (ClickUp 869e8adqb, Kea):
     Frei-Text wie "kann ich mit einem Mitarbeiter sprechen?" fuehrt nach der
     Bot-Antwort direkt zur Uebergabe (WhatsApp + E-Mail) statt zum
     "Konnte ich helfen?"-Umweg. Bewusst eng: es muss eine PERSON gemeint
     sein UND ein Kontaktwunsch dabeistehen, sonst greift es bei Fragen wie
     "was macht euer Kundenservice bei Retouren?" faelschlich. */
  function isHumanAsk(s) {
    var who = /(mensch|mitarbeiter|berater|kundenservice|kundendienst|echte[rn]? person|kollege|kollegin)/;
    var want = /(sprechen|reden|telefon|anruf|kontakt|erreich|verbind|schreiben|weiterleit|durchstell)/;
    return who.test(s) && want.test(s);
  }

  /* wa.me-Deeplink: oeffnet WhatsApp beim Kunden (App auf dem Handy,
     WhatsApp Web am Desktop) mit vorbereiteter Nachricht an unsere
     Business-Nummer. Der Kunde muss selbst auf Senden druecken.
     Kein Link, wenn keine Nummer konfiguriert ist -> nur E-Mail-Weg. */
  function waHref() {
    var num = String(CFG.waNumber || '').replace(/[^0-9]/g, '');
    if (!num) return null;
    var lines = [];
    if (PRODUCT && PRODUCT.title) {
      var vt = state.variant && state.variant.title && state.variant.title !== 'Default Title'
        ? ' (' + state.variant.title + ')' : '';
      lines.push('Meine Frage betrifft: ' + PRODUCT.title + vt);
    }
    if (state.lastQuestion) lines.push(state.lastQuestion);
    var txt = (CFG.waPrefill || 'Hallo LILIMAUS-Team,') + (lines.length ? '\n\n' + lines.join('\n') : ' ');
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(txt);
  }

  var OFFLINE_TEXT =
    'Entschuldige – ich bin gerade nicht erreichbar. Unser Team hilft dir aber sofort weiter: ' +
    'Hinterlasse unten deine E-Mail-Adresse, wir melden uns schnellstmöglich.';

  function askQuestion(q) {
    state.lastQuestion = q;
    state.sessionActive = true; // ab jetzt Session ueber Seitenwechsel mitnehmen
    addMsg('user', q);
    logEvent('question', { text: q });
    var wantsCode = isDiscountAsk(q.toLowerCase());
    var asksPrice = !wantsCode && isPriceAsk(q.toLowerCase());
    var wantsHuman = !wantsCode && isHumanAsk(q.toLowerCase());
    var typing = showTyping();

    // Nach der vollstaendigen Antwort: Ticket (Fehler) / Gutschein (Rabatt-
    // ODER Preisfrage) / sonst Follow-up ("Konnte ich helfen?").
    function afterAnswer(isError) {
      if (isError) {
        // Backend nicht erreichbar/deaktiviert: direkt den Weg zum Team zeigen
        showTicketForm(false);
        return;
      }
      if (wantsCode || asksPrice) {
        // Direkt die Gutschein-Karte, ohne "War das hilfreich?"-Umweg;
        // nach Seitenwechsel darf sie dafuer neu gerendert werden.
        // Preisfrage: Antwort verweist auf die Produktseite, der Gutschein
        // darunter ist der Kauf-Verstaerker.
        state.rerenderThanks = true;
        showThankYou();
        return;
      }
      if (wantsHuman) {
        // Ausdruecklicher Wunsch nach einem Menschen -> direkt die Uebergabe
        // (WhatsApp-Knopf + E-Mail-Formular), kein "Konnte ich helfen?".
        logEvent('handoff_click', { source: 'freitext' });
        showTicketForm(true);
        return;
      }
      // Kein automatischer Gutschein mehr (Ansage Marc 2026-07-08). Stattdessen
      // Follow-up: Kunde markiert das Thema als erledigt -> DANN kommt der Gutschein.
      offerFollowup();
    }

    // Bot-Blase mit gleichmaessigem "Tipp"-Tempo. WICHTIG: die Anzeige ist vom
    // Netzwerk-Takt ENTKOPPELT — ankommender Text wandert in eine Warteschlange
    // (queue) und wird mit ruhiger, konstanter Geschwindigkeit Zeichen fuer
    // Zeichen sichtbar gemacht. Sonst springt die Antwort in wenigen grossen
    // Bloecken rein (Claude streamt grobe Haeppchen; kleine Responses werden
    // unterwegs oft zusammengefasst) und es sieht nicht nach Tippen aus.
    function makeSink() {
      var bubble = null;
      var shown = '';      // bereits sichtbar
      var queue = '';      // angekommen, noch nicht getippt
      var streamDone = false, doneErr = false, finalized = false, ticking = false;
      var STEP_MS = 30;    // ~33 Tipp-Schritte/Sekunde

      function ensureBubble() {
        if (!bubble) {
          if (typing.parentNode) typing.remove();
          bubble = el('div', 'lmchat-msg --bot --typing'); // Schreib-Cursor bis fertig
          msgsEl.appendChild(bubble);
        }
      }
      function tick() {
        if (queue.length) {
          ensureBubble();
          // Grundtempo ~6 Zeichen/Schritt (~200 Z/s); bei Rueckstand aufholen.
          // Ist der Stream schon fertig, liegt die ganze Antwort vor — dann
          // deutlich schneller austippen, der Kunde soll nicht auf die
          // Animation warten (Feedback 2026-07-28: fuehlte sich lahm an).
          var n = Math.min(queue.length, (streamDone ? 16 : 6) + Math.floor(queue.length / 40));
          shown += queue.slice(0, n);
          queue = queue.slice(n);
          bubble.innerHTML = richHtml(shown);
          scrollDown();
        }
        if (queue.length) {
          setTimeout(tick, STEP_MS);
        } else if (streamDone) {
          ticking = false;
          finalize();
        } else {
          ticking = false; // Puffer leer -> pausieren, bis neuer Text kommt
        }
      }
      function ensureTicking() { if (!ticking) { ticking = true; setTimeout(tick, STEP_MS); } }
      function finalize() {
        if (finalized) return;
        finalized = true;
        if (!bubble) { // gar kein Text angekommen -> Offline-Hinweis
          ensureBubble();
          shown = OFFLINE_TEXT;
          bubble.textContent = OFFLINE_TEXT;
          doneErr = true;
        }
        if (bubble) bubble.classList.remove('--typing'); // Cursor weg
        state.transcript.push({ who: 'bot', text: shown });
        saveSession();
        markUnread();
        scrollDown();
        afterAnswer(doneErr);
      }
      return {
        push: function (t) { if (t) { queue += t; ensureTicking(); } },
        hasText: function () { return !!bubble || shown.length > 0 || queue.length > 0; },
        finish: function (isError) {
          streamDone = true; doneErr = isError;
          if (queue.length) ensureTicking(); else finalize();
        }
      };
    }

    if (DEMO) {
      setTimeout(function () {
        var a = demoAnswer(q);
        logEvent('answer_demo', { text: a });
        // Wie im Live-Fall: ganzer Text in die Warteschlange, der Pacer tippt ihn.
        var sink = makeSink();
        sink.push(a);
        sink.finish(false);
      }, 340 + Math.random() * 220);
      return;
    }

    var payload = {
      sessionId: getSessionId(),
      mode: MODE,
      page: location.href.slice(0, 500),
      question: q.slice(0, 800),
      messages: state.transcript.slice(-12, -1), // ohne die eben angefuegte Frage
      product: PRODUCT ? { handle: PRODUCT.handle, title: PRODUCT.title } : null,
      variant: state.variant ? state.variant.title : null
    };
    var sink = makeSink();
    streamChat(payload, {
      onDelta: function (t) { sink.push(t); },
      onDone: function (hadError) { sink.finish(hadError); }
    }).catch(function () {
      // Streaming nicht moeglich -> klassischer Endpoint als Rueckfall
      if (sink.hasText()) { sink.finish(true); return; }
      api('/api/chat', payload)
        .then(function (res) {
          var reply = (res && res.reply) || OFFLINE_TEXT;
          sink.push(reply);
          sink.finish(!!(res && res.error) || !res || !res.reply);
        })
        .catch(function () { sink.push(OFFLINE_TEXT); sink.finish(true); });
    });
  }

  /* ---------------- Demo-Antworten ----------------
     TODO (Phase 2): ersetzen durch sendToBot(q, context) ->
     LILIMAUS-OS-Endpoint (KI + CS-Wiki + Produktdatenbank). */
  function demoAnswer(q) {
    var name = PRODUCT ? PRODUCT.title : 'das Produkt';
    var vt = state.variant ? state.variant.title : null;
    var vPart = vt ? ' in der Variante "' + vt + '"' : '';
    var s = q.toLowerCase();
    // Aktive Rabatt-/Gutschein-Nachfrage (beide Modi): Dankeschoen-Code
    // anbieten – die Karte haengt askQuestion() direkt an.
    // Phase 2: Hier erzeugt der Server einen echten Einmal-Code (24h,
    // usageLimit 1); der Bot kennt selbst KEINE statischen Codes.
    if (isDiscountAsk(s)) {
      return 'Sehr gern! Als kleines Dankeschön dafür, dass du LILI ausprobierst, schenke ich dir 10 % auf deine Bestellung – hier ist dein persönlicher Code:';
    }
    // Support-Modus (Kontaktseite): Self-Service-Themen zuerst
    if (MODE === 'support') {
      if (/(bestell|sendung|tracking|wo ist|paket|versandstatus|lieferstatus)/.test(s)) {
        return 'Das schaue ich sofort nach! Sag mir deine Bestellnummer (z. B. #12345) oder die E-Mail-Adresse deiner Bestellung. In der fertigen Version zeige ich dir dann direkt den Status, die Sendungsverfolgung und das voraussichtliche Lieferdatum.';
      }
      if (/(retoure|zurück|zurueck|umtausch|rückgabe|rueckgabe|widerruf|reklam)/.test(s)) {
        return 'Kein Problem: Du hast 30 Tage Rückgaberecht. Dein DHL-Retourenlabel kommt von uns per E-Mail – du musst kein Porto auslegen; dafür behalten wir 5 € (Deutschland) bzw. 7,50 € (Österreich) von der Erstattung ein. Sag mir deine Bestellnummer, dann starte ich die Retoure für dich.';
      }
      if (/(rechnung|invoice|beleg)/.test(s)) {
        return 'Deine Rechnung bekommst du automatisch per E-Mail, sobald deine Bestellung verschickt ist. Nicht gefunden? Gib mir deine Bestellnummer, dann schicke ich sie dir gleich noch einmal.';
      }
      if (/(adresse|ändern|aendern|storno|stornieren|abbrechen)/.test(s)) {
        return 'Solange deine Bestellung noch nicht verpackt ist, können wir das ändern. Gib mir deine Bestellnummer und die gewünschte Änderung – ich leite es sofort an unser Team weiter.';
      }
      if (/(gutschein|rabattcode|code)/.test(s)) {
        return 'Deinen Gutscheincode löst du an der Kasse im Feld "Gutscheincode" ein. Klappt es nicht, nenn mir den Code – ich prüfe ihn für dich.';
      }
      if (/(zahlung|klarna|paypal|raten|kreditkarte|bezahl)/.test(s)) {
        return 'Wir akzeptieren PayPal, Kreditkarte, Klarna (auch Ratenkauf), Apple Pay und mehr. Alle Zahlarten siehst du im letzten Schritt an der Kasse.';
      }
      if (/(produkt)/.test(s)) {
        return 'Gern! Am einfachsten fragst du mich direkt auf der jeweiligen Produktseite – dort kenne ich die gewählte Variante und alle Details. Du kannst mir deine Frage aber auch einfach hier schreiben.';
      }
    }
    // Spezifische Themen ZUERST, generische (Groesse/Material/Lieferung) danach
    if (/(leucht|dunkel|nacht)/.test(s)) {
      return 'Die Leuchtelemente laden sich tagsüber über normales Licht auf und leuchten nach dem Lichtausschalten mehrere Stunden sanft nach – ganz ohne Strom oder Batterien, ideal zum Einschlafen.';
    }
    if (/(kleb|halt|wand|tapete|rückstand|rueckstand|entfern)/.test(s)) {
      return 'Sie haften auf glatten, trockenen Untergründen wie Wandfarbe, Tapete oder Möbeln und lassen sich später rückstandslos wieder ablösen. Bei frisch gestrichenen Wänden empfehlen wir, 2-3 Wochen zu warten.';
    }
    if (/(matratze|steg|spannbett)/.test(s)) {
      return name + vPart + ' hat einen Rundumgummi und passt auf Matratzen bis ca. 12 cm Höhe – die genauen Maße je Größe findest du in der Größentabelle. Sag mir gern die Maße deiner Matratze, dann prüfe ich das für dich.';
    }
    if (/(reißverschluss|reissverschluss|knopf|knöpfe|knoepfe|verschluss)/.test(s)) {
      return 'Unsere Bettwäsche schließt mit hochwertigen Druckknöpfen – nichts kratzt, nichts zwickt, und das Beziehen geht schnell.';
    }
    if (/(einlauf|schrumpf)/.test(s)) {
      return 'Musselin ist vorgewaschen – bei 30 Grad im Schonwaschgang behält ' + name + ' seine Form. Nur der Trockner ist tabu, dann bleibt alles wie am ersten Tag.';
    }
    if (/(füllung|fuellung|inlett|inlay)/.test(s)) {
      return 'Ja, die Füllung ist dabei – Bezug und Inlett sind getrennt, der Bezug lässt sich zum Waschen einfach abnehmen.';
    }
    if (/(alter|baby|geeignet|monat)/.test(s)) {
      return name + ' ist hautfreundlich und schadstoffgeprüft. Bitte beachte: Produkte mit Bändern oder kleinen Teilen gehören nicht unbeaufsichtigt ins Babybett – Details stehen in der Produktbeschreibung.';
    }
    if (/(montage|anbring|aufhäng|aufhaeng|befestig|decke|halterung|stange|montier)/.test(s)) {
      return 'Die Anbringung ist unkompliziert: Eine bebilderte Anleitung liegt bei, du brauchst nur wenige Handgriffe. Für ' + name + ' gibt es passendes Befestigungs-Zubehör bei uns im Shop – soll ich es dir zeigen?';
    }
    if (/(größe|groesse|groß|gross|mass|maß|abmess|passt|breite|länge|laenge|wie lang)/.test(s)) {
      return 'Gute Frage! Alle Maße von ' + name + vPart + ' findest du in der Größentabelle weiter unten auf dieser Seite. Kurz gesagt: Die Variante ist so geschnitten, dass sie für die gängigen Kinderbett-Größen passt. Sag mir gern die Maße deines Bettes, dann prüfe ich das für dich.';
    }
    if (/(material|stoff|pflege|wasch|baumwolle|musselin|oeko|öko|schadstoff)/.test(s)) {
      return name + ' besteht aus 100 % Baumwoll-Musselin, ist hautfreundlich und schadstoffgeprüft. Waschbar bei 30 Grad im Schonwaschgang, nicht trocknergeeignet. So bleibt der Stoff schön weich für dein Kind.';
    }
    if (/(liefer|versand|ankommen|dauert|wann|dhl)/.test(s)) {
      return 'Wir versenden mit DHL direkt aus Deutschland: Bestellungen bis 14 Uhr gehen noch am selben Werktag raus, Lieferzeit 1-3 Werktage. ' + (vt ? 'Die Variante "' + vt + '" ist aktuell auf Lager.' : '');
    }
    if (/(preis|kostet|angebot|sale)/.test(s)) {
      return 'Der aktuelle Preis' + (state.variant && state.variant.price ? ' für "' + vt + '" ist ' + state.variant.price : ' steht direkt über dem Warenkorb-Button') + '. Und ein kleiner Tipp: Frag mich ruhig nach einem Gutschein.';
    }
    if (MODE === 'support') {
      return 'Danke für deine Nachricht! In der fertigen Version beantworte ich das mit dem Wissen aus unserem Kundenservice – oder reiche es direkt an einen Menschen weiter. (Design-Demo: Diese Antwort ist ein Beispieltext.) Hilft dir das weiter?';
    }
    return 'Danke für deine Frage zu ' + name + vPart + '! In der fertigen Version beantworte ich das mit dem Wissen aus unserem Kundenservice. (Design-Demo: Diese Antwort ist ein Beispieltext.) Hilft dir das weiter?';
  }

  // Follow-up nach jeder Antwort: der Kunde markiert das Thema als erledigt
  // ("Ja, das war's") -> DANN erscheint der Dankeschoen-Gutschein. Zusaetzlich
  // weiterfragen oder an einen Menschen uebergeben. Kein Cross-Selling.
  function offerFollowup() {
    var fb = el('div', 'lmchat-feedback');
    fb.innerHTML = '<span>' + esc(CFG.feedbackQuestion) + '</span>';
    var done = el('button', null, null); done.type = 'button'; done.textContent = CFG.resolvedDone;
    var more = el('button', null, null); more.type = 'button'; more.textContent = CFG.resolvedMore;
    var no = el('button', null, null); no.type = 'button'; no.textContent = CFG.feedbackNo;

    done.addEventListener('click', function () {
      fb.remove();
      logEvent('feedback', { helpful: true, resolved: true, question: state.lastQuestion });
      addMsg('user', CFG.resolvedDone);
      addMsg('bot', CFG.afterDone);
      state.rerenderThanks = true; // Erledigt = expliziter Trigger -> Gutschein zeigen
      showThankYou();
    });
    more.addEventListener('click', function () {
      fb.remove();
      addMsg('user', CFG.resolvedMore);
      addMsg('bot', CFG.moreIntro);
      if (window.matchMedia('(min-width: 641px)').matches && inputEl) inputEl.focus();
    });
    no.addEventListener('click', function () {
      fb.remove();
      logEvent('feedback', { helpful: false, question: state.lastQuestion });
      addMsg('bot', CFG.ticketIntro);
      showTicketForm(false);
    });

    fb.appendChild(done);
    fb.appendChild(more);
    fb.appendChild(no);
    msgsEl.appendChild(fb);
    scrollDown();
  }

  /* ---------------- Dankeschoen + Upsell ----------------
     Gutschein IMMER als Dankeschoen fuer die LILI-Nutzung (einmal
     pro Seitenaufruf), darunter der Upsell. Demo: Shopify-
     Recommendations als Platzhalter, Code ist ein Dummy.
     Phase 2: echter personalisierter 24h-Code (Admin-API, endsAt
     = now+24h, usageLimit 1) + Co-Purchase aus BigQuery. */
  function showThankYou() {
    if (state.thanksShown) {
      // Karte gibt es schon (z. B. zweite Rabatt-Nachfrage) -> hinscrollen;
      // nach Seitenwechsel existiert sie nicht mehr im DOM -> neu rendern
      var card = msgsEl && msgsEl.querySelector('.lmchat-upsell');
      if (card) {
        card.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (!state.rerenderThanks) return; // Auto-Trigger rendert nicht erneut
    }
    var explicitAsk = state.rerenderThanks;
    state.rerenderThanks = false;

    if (DEMO) {
      state.thanksShown = true;
      saveSession();
      renderThankYouCard({ code: CFG.voucherCode, endsAt: null });
      return;
    }

    // Live: echter persoenlicher Einmal-Code vom Backend (feste Regeln)
    api('/api/voucher', { sessionId: getSessionId() })
      .then(function (res) {
        if (res && res.code) {
          state.thanksShown = true;
          saveSession();
          renderThankYouCard(res);
        } else if (res && res.error === 'limit') {
          state.thanksShown = true;
          saveSession();
          if (explicitAsk) addMsg('bot', CFG.voucherAlready || 'Dein persönlicher Code aus dieser Sitzung gilt weiterhin – schau einmal oben im Verlauf.');
        }
        // andere Fehler: Karte still weglassen, spaetere Nachfrage darf es erneut versuchen
      })
      .catch(function () { /* still bleiben – Gutschein ist ein Bonus, kein Blocker */ });
  }

  // Baut die Gutschein-Karte (reines DOM + Timer) — auch fuer den Replay
  // nach Seitenwechsel. Keine Nebeneffekte (Logging/Badge/Save).
  function appendVoucherCard(data) {
    var pct = (data && data.percent) || CFG.voucherPercent || 10;
    var benefit = (CFG.voucherBenefit || '{p} % Rabatt auf deine Bestellung').replace('{p}', pct);
    var card = el('div', 'lmchat-upsell');
    card.innerHTML =
      '<div class="lmchat-upsell__head">' + esc(CFG.thankHead) + '</div>' +
      '<div class="lmchat-upsell__benefit">' + esc(benefit) + '</div>' +
      '<div class="lmchat-upsell__voucher">' +
      '<span>' + esc(CFG.voucherText) + '</span>' +
      '<span class="lmchat-upsell__code">' + esc(data.code) + '</span>' +
      '<span class="lmchat-upsell__timer" data-lmchat-timer></span>' +
      '</div>';
    msgsEl.appendChild(card);
    startVoucherTimer(card.querySelector('[data-lmchat-timer]'), data.endsAt);
    return card;
  }

  function renderThankYouCard(data) {
    // Gutschein in der Session merken, damit er beim Seitenwechsel mitkommt
    state.voucher = {
      code: data.code,
      endsAt: data.endsAt || null,
      percent: (data && data.percent) || CFG.voucherPercent || 10
    };
    appendVoucherCard(state.voucher);
    scrollDown();
    logEvent('thankyou_shown', {});
    markUnread();
    saveSession();
    // Cross-Selling / Produktempfehlung: auf Ansage Marc 2026-07-08 komplett entfernt.
  }

  /* Gutschein-Countdown: live gegen die ECHTE Server-Ablaufzeit (endsAt);
     Demo ohne endsAt faellt auf einen lokalen 24h-Timer zurueck. */
  function startVoucherTimer(elTimer, endsAtIso) {
    if (!elTimer) return;
    var until = endsAtIso ? Date.parse(endsAtIso) : 0;
    if (!until || isNaN(until)) {
      var key = 'lmchat-voucher-until';
      try {
        until = parseInt(localStorage.getItem(key) || '0', 10);
        if (!until || until < Date.now()) {
          until = Date.now() + 24 * 3600 * 1000;
          localStorage.setItem(key, String(until));
        }
      } catch (e) { until = Date.now() + 24 * 3600 * 1000; }
    }
    function tick() {
      var left = Math.max(0, until - Date.now());
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      elTimer.textContent = left > 0 ? 'noch ' + h + ' h ' + (m < 10 ? '0' : '') + m + ' min' : 'abgelaufen';
      if (left > 0) setTimeout(tick, 30000);
    }
    tick();
  }

  /* ---------------- Uebergabe an Kundenservice ----------------
     Zwei Wege zum Menschen: (a) Feedback "Nein" nach einer Antwort,
     (b) jederzeit ueber den Link unter der Eingabe. Der komplette
     Chat-Verlauf geht mit ans Team.
     TODO (Phase 2): createTicket() -> LILIMAUS-OS Ticketsystem
     (Kanal "Shop-Chat"), inkl. Transkript, Produkt, Variante, URL. */
  function showTicketForm(isHandoff) {
    var existing = msgsEl.querySelector('.lmchat-ticket');
    if (existing) {
      existing.scrollIntoView({ block: 'center', behavior: 'smooth' });
      existing.querySelector('input').focus();
      return;
    }
    if (isHandoff) addMsg('bot', CFG.handoffIntro);
    // WhatsApp zuerst: der Kunde schreibt uns aus seinem eigenen WhatsApp,
    // die Antwort erreicht ihn dort. PFLICHT-Hinweis (Ansage Linus 2026-09-02):
    // Antwort kann bis zu 24 h dauern, in der Regel geht es deutlich schneller.
    var waUrl = waHref();
    if (waUrl) {
      var waCard = el('div', 'lmchat-wa');
      waCard.innerHTML =
        '<div class="lmchat-wa__title">' + esc(CFG.waTitle || 'Lieber direkt per WhatsApp?') + '</div>' +
        '<a class="lmchat-wa__btn" target="_blank" rel="noopener noreferrer">' + ICON_WA +
        '<span>' + esc(CFG.waCta || 'Per WhatsApp schreiben') + '</span></a>' +
        '<div class="lmchat-wa__note">' + esc(CFG.waNote || '') + '</div>' +
        '<div class="lmchat-wa__or"><span>' + esc(CFG.waOr || 'oder per E-Mail') + '</span></div>';
      var waLink = waCard.querySelector('.lmchat-wa__btn');
      waLink.href = waUrl;
      waLink.addEventListener('click', function () {
        logEvent('whatsapp_click', { handoff: !!isHandoff, question: state.lastQuestion });
      });
      msgsEl.appendChild(waCard);
    }
    var form = el('div', 'lmchat-ticket');
    form.innerHTML =
      '<div class="lmchat-ticket__title">' + esc(CFG.ticketTitle) + '</div>' +
      '<div class="lmchat-ticket__hint">' + esc(CFG.ticketHint) + '</div>' +
      '<input type="text" placeholder="Dein Name" aria-label="Dein Name" maxlength="80" autocomplete="name" required>' +
      '<input type="email" placeholder="deine@email.de" aria-label="E-Mail-Adresse" required>' +
      '<textarea aria-label="Deine Frage"></textarea>' +
      '<span class="lmchat-ticket__error">' + esc(CFG.ticketError) + '</span>' +
      '<button type="button" class="lmchat-ticket__send">' + esc(CFG.ticketSend) + '</button>';
    var nameIn = form.querySelector('input[type=text]');
    var email = form.querySelector('input[type=email]');
    var msg = form.querySelector('textarea');
    var errEl = form.querySelector('.lmchat-ticket__error');
    var sendBtn = form.querySelector('.lmchat-ticket__send');
    msg.value = state.lastQuestion || '';
    sendBtn.addEventListener('click', function () {
      var nameVal = (nameIn.value || '').trim();
      var mail = (email.value || '').trim();
      if (nameVal.length < 2) {
        errEl.textContent = CFG.ticketErrorName || 'Bitte gib deinen Namen ein.';
        form.classList.add('--error');
        nameIn.focus();
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) {
        errEl.textContent = CFG.ticketError;
        form.classList.add('--error');
        email.focus();
        return;
      }
      form.classList.remove('--error');

      function done() {
        form.remove();
        addMsg('bot', CFG.ticketDone);
      }

      if (DEMO) {
        logEvent('ticket_created_demo', {
          email: mail, name: nameVal, question: msg.value, handoff: !!isHandoff, transcript: state.transcript.slice(-20)
        });
        done();
        return;
      }

      // Live: Uebergabe als E-Mail ans Team (-> Ticketsystem). Server loggt selbst.
      sendBtn.disabled = true;
      sendBtn.textContent = CFG.ticketSending || 'Wird gesendet …';
      api('/api/ticket', {
        sessionId: getSessionId(),
        email: mail,
        name: nameVal,
        question: msg.value,
        messages: state.transcript.slice(-20),
        mode: MODE,
        page: location.href.slice(0, 500),
        productHandle: PRODUCT ? PRODUCT.handle : null,
        variant: state.variant ? state.variant.title : null
      })
        .then(function (res) {
          if (res && res.ok) {
            done();
          } else {
            sendBtn.disabled = false;
            sendBtn.textContent = CFG.ticketSend;
            addMsg('bot', CFG.ticketFailed || 'Das hat gerade nicht geklappt. Bitte schreib uns direkt an ' + (CFG.supportEmailText || 'unsere Service-Adresse') + '.');
          }
        })
        .catch(function () {
          sendBtn.disabled = false;
          sendBtn.textContent = CFG.ticketSend;
          addMsg('bot', CFG.ticketFailed || 'Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.');
        });
    });
    msgsEl.appendChild(form);
    scrollDown();
    email.focus();
  }

  /* ---------------- Oeffnen/Schliessen ---------------- */
  function openPanel() {
    if (!panel) buildPanel();
    refreshVariant();
    renderContext();
    state.open = true;
    state.sessionActive = true; // Oeffnen = Chat-Start -> ab jetzt auf allen Seiten verfuegbar
    panel.classList.add('--open');
    backdrop.classList.add('--open');
    fab.classList.add('--hidden');
    fab.classList.remove('--unread'); // gelesen -> Badge weg
    fab.setAttribute('aria-expanded', 'true');
    greet();
    saveSession();
    logEvent('open');
    // Desktop: direkt in die Eingabe; Mobile nicht (Keyboard wuerde aufpoppen)
    if (window.matchMedia('(min-width: 641px)').matches) inputEl.focus();
  }

  function closePanel() {
    state.open = false;
    panel.classList.remove('--open');
    backdrop.classList.remove('--open');
    fab.classList.remove('--hidden');
    fab.classList.add('--collapsed');
    fab.setAttribute('aria-expanded', 'false');
    saveSession();
    logEvent('close');
  }

  /* ---------------- Init ---------------- */
  function init() {
    var sess = loadSession();

    // Browse-Seiten (Startseite, Collections, Cart, ...): Chat erst
    // anbieten, nachdem der Kunde ihn irgendwo gestartet hat.
    if (CFG.requireSession && !(sess && sess.active)) return;

    buildFab();

    // Mobil: FAB erst 10 s nach BESUCHSBEGINN einblenden (Ansage Linus 2026-08-11).
    // Wichtig: Die 10 s laufen einmal pro Browser-Session (sessionStorage-Zeitstempel),
    // NICHT pro Seite - sonst sieht ein Kunde, der schneller als 10 s pro Seite
    // weiterklickt, den Button nie (Befund Linus 11.08.). Bei aktiver Chat-Session
    // sofort zeigen, sonst verschwaende der Button mitten im Gespraech.
    if (!(sess && sess.active) && window.matchMedia('(max-width: 640px)').matches) {
      var introT0 = 0;
      try { introT0 = parseInt(sessionStorage.getItem('lmchat_intro_t0') || '0', 10) || 0; } catch (e) {}
      if (!introT0) {
        introT0 = Date.now();
        try { sessionStorage.setItem('lmchat_intro_t0', String(introT0)); } catch (e) {}
      }
      var introRemaining = 10000 - (Date.now() - introT0);
      if (introRemaining > 0) {
        fab.classList.add('--intro-wait');
        setTimeout(function () { fab.classList.remove('--intro-wait'); }, introRemaining);
      }
    }

    watchStickyBar();
    watchOverlays();

    if (MODE === 'product') {
      watchVariant();
      refreshVariant();
    }

    // Bestehende Chat-Session aus vorheriger Seite fortsetzen
    if (sess && sess.active) {
      state.sessionActive = true;
      state.thanksShown = !!sess.thanksShown;
      state.savedTranscript = sess.transcript || null;
      state.voucher = sess.voucher || null; // ausgegebener Gutschein mitnehmen
      if (sess.open) {
        openPanel(); // Chat war offen -> auf der neuen Seite direkt wieder oeffnen
      } else {
        fab.classList.add('--collapsed'); // Kunde kennt den Chat schon -> kompakt
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
